<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-07",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 27,
      nextPage: '/questionnaire/section2/8',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Digestion.png'),
        mainTitle: 'What is your bowel status?',
        btn: [
          [
            {
              text: 'Normal',
            }
          ],[
            {
              text: 'Occasionally consipation',
            }
          ],[
            {
              text: 'Frequent consipation',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
